import React from 'react';
import './RouteHandler.css';

import withRouter from 'lib/withRouter';

import indicatorGroups from 'data/indicatorGroups.json';
import indicatorsDataJson from 'data/indicatorsData.json';
import DetailedIndicatorEntry from 'components/DetailedIndicatorEntry/DetailedIndicatorEntry';
import { Spinner } from 'react-bootstrap';
import { ChartData } from 'components/Chart/Chart';

import colors from 'data/colors.json';

interface IndicatorData {
    [key: string]: IndicatorDataEntry[];
}

export interface DataEntry {
    name: string;
    values: (number | string)[];
    numDigits: number[];
    chart: boolean;
    provisional: boolean; 
}

export interface IndicatorDataEntry {
    code: string;
    title: string;
    source: string;
    schema: Record<string, any>[];
    data: DataEntry[];
    annotations?: {
        de: string[];
        it: string[];
    }
}

const indicatorsData : IndicatorData = indicatorsDataJson;

interface Props {
    searchParams: URLSearchParams;
}

class RoutHandler extends React.Component<Props, { data: ChartData | null, dataDefinition: IndicatorDataEntry | null, loadSuccessful: boolean }> {
    constructor(props: Props) {
        super(props);

        const parentLang = this.props.searchParams.get("lang");

        if (parentLang != null) {
            window.lang = parentLang;
        } else {
            window.lang = "de";
        }

        this.state = {
            data: null,
            dataDefinition: null,
            loadSuccessful: false,
        };
    }

    private loadData(indicatorGroup: string | null, indicator: string | null, dataId: string | null) {
        if (!indicatorGroup || !indicator || !dataId) {
            this.setState({ loadSuccessful: false });
            return;
        }

        const groupEntry = indicatorGroups.find(entry => entry.group === indicatorGroup);
        if (!groupEntry) {
            this.setState({ loadSuccessful: false });
            return;
        }
        const indicatorEntry = groupEntry.members.find(entry => entry === indicator);
        if (!indicatorEntry) {
            this.setState({ loadSuccessful: false });
            return;
        }
        const definitionEntry = indicatorsData[indicatorGroup].find(entry => entry.code === indicator);
        if (!definitionEntry) {
            this.setState({ loadSuccessful: false });
            return;
        }
        const dataEntry = definitionEntry.data.find(entry => entry.name === dataId);
        if(!dataEntry){
            this.setState({ loadSuccessful: false });
            return;
        }
        
        const definitionEntryC = Object.assign({}, definitionEntry);
        definitionEntryC.data = [dataEntry];

        import(`data/${indicator}Complete.json`).then(({ default: jsonData }) => {
            //console.log("Data complete:", jsonData);
            const data: ChartData | null = jsonData.data.find((entry: ChartData) => entry.name === dataId);
            if (!data) {
                this.setState({ loadSuccessful: false });
                return;
            }

            this.setState({ data: data, dataDefinition: definitionEntryC, loadSuccessful: true });
        }).catch(() => {
            this.setState({ loadSuccessful: false });
        });
    }

    componentDidMount(): void {
        this.loadData(this.props.searchParams.get("group"), this.props.searchParams.get("indicGroup"), this.props.searchParams.get("indicID"));
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        const eq = (key: string) => prevProps.searchParams.get(key) === this.props.searchParams.get(key);

        if(!eq("group") || !eq("indicGroup") || !eq("indicID")) {
            this.loadData(this.props.searchParams.get("group"), this.props.searchParams.get("indicGroup"), this.props.searchParams.get("indicID"));
        }
    }

    render(): React.ReactNode {
        //console.log("Search params:", this.props.searchParams);

        if (this.state.loadSuccessful) {
            //console.log("dataDefinition:", this.state.dataDefinition);
            //console.log("data:", this.state.data);
            return (<DetailedIndicatorEntry dataDefinition={this.state.dataDefinition!} data={this.state.data!} />);
        }

        return (
            <div className="loading-indicator-container">
                <Spinner className="loading-indicator" animation="border" role="status" style={{ color: colors[0] }}>
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }
}

export default withRouter(RoutHandler);